import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Testimonials from './components/Testimonials'; // 1. Import it
import ScrollToTop from './components/ScrollToTop'; // 1. Import the component
import MobileNavbar from './components/MobileNavbar';
// Page Imports
import Home from './pages/Home';
import Services from './pages/Services';
import About from './pages/About';
import WhyUs from './pages/WhyUs';
import Contact from './pages/Contact';

function App() {
  return (
    <Router>
      <div className="flex flex-col min-h-screen">
        {/* 2. Place it here so it runs on every route change */}
        <ScrollToTop /> 
        
        <Header />
        
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/about" element={<About />} />
            <Route path="/why-optirev" element={<WhyUs />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
        
         <Testimonials />
         <MobileNavbar />
        <Footer />
      </div>
    </Router>
  );
}

export default App;